module.exports = __webpack_public_path__ + "assets/pinterest.b9f0946c.svg";